/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerStopFilled = createReactComponent(
  "player-stop-filled",
  "IconPlayerStopFilled",
  [
    [
      "path",
      {
        d: "M17 4h-10a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
);

export { IconPlayerStopFilled as default };
//# sourceMappingURL=IconPlayerStopFilled.js.map
